import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'fx-brokers-h',
  templateUrl: './fx-brokers-h.component.html',
  styleUrls: ['./fx-brokers-h.component.css'],
})

export class FXBrokersHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | FX Broker Event Log");

    var mainNav = "history-nav";
    //var sideNavTab = "side-nav-tab-eventlog";
    var sideNav = "side-nav-history-liquidity-providers";

    $(document).ready(function() {
      // prepare the data
      var data = [ {
        "timestamp" : "5/5/2015 06:08:46.689",
        "user" : "System",
        "ipAddress" : "12.56.8.32",
        "brokerID" : "5123",
        "brokerCode" : "JPM",
        "displayName" : "JP Morgan"
      }, {
        "timestamp" : "5/5/2015 06:08:47.577",
        "user" : "System",
        "ipAddress" : "12.56.8.32",
        "brokerID" : "9943",
        "brokerCode" : "CS",
        "displayName" : "Credit Suisse"
      }, {
        "timestamp" : "5/5/2015 06:08:47.989",
        "user" : "System",
        "ipAddress" : "12.56.8.32",
        "brokerID" : "5184",
        "brokerCode" : "HSBC",
        "displayName" : "HSBC"
      } ];

      // initialize jqxGrid
      var source = {
        localdata : data,
        datafields : [ {
          name : 'timestamp',
          type : 'string'
        }, {
          name : 'user',
          type : 'string'
        }, {
          name : 'ipAddress',
          type : 'string'
        }, {
          name : 'brokerID',
          type : 'string'
        }, {
          name : 'brokerCode',
          type : 'string'
        }, {
          name : 'displayName',
          type : 'string'
        } ]
      };
      var settings = defaultGridViewSettings("#jqxgrid", source);
      settings.columns = [ {
        text : 'Timestamp',
        columntype : 'textbox',
        datafield : 'timestamp',
        width : '160'
      }, {
        text : 'User',
        columntype : 'textbox',
        datafield : 'user',
        width : '100'
      }, {
        text : 'IP Address',
        columntype : 'textbox',
        datafield : 'ipAddress',
        width : '80'
      }, {
        text : 'External Broker ID',
        columntype : 'textbox',
        datafield : 'brokerID',
        width : '120'
      }, {
        text : 'Broker Code',
        columntype : 'textbox',
        datafield : 'brokerCode',
        width : '100'
      }, {
        text : 'Display Name',
        columntype : 'textbox',
        datafield : 'displayName',
        width : '150'
      } ];
      $("#jqxgrid").jqxGrid(settings);
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/fx-brokers-h/fx-brokers-h.component.ts